module.exports = __webpack_public_path__ + "assets/80.jpg?5a2aefa4590203ec3d78c97cb0d2da83";